import { Button, Group } from "@mantine/core";
import { SiteSetupProcessDataStep } from "../../../../types/api.types";

interface SiteSetupAssistantFormControlsProps {
  activeStep: SiteSetupProcessDataStep;
  isCreating: boolean;
  isSubmitting: boolean;
  navigationBlocked?: boolean;
  onCancel: () => void;
  onSaveProgress: () => Promise<void>;
  onCreateSite: () => Promise<void>;
}

function SiteSetupAssistantFormControls({
  activeStep,
  isCreating,
  isSubmitting,
  navigationBlocked,
  onSaveProgress,
  onCancel,
  onCreateSite
}: SiteSetupAssistantFormControlsProps) {
  return (
    <Group className="SiteSetupAssistantFormControls" justify="center">
      <Button
        disabled={isSubmitting || isCreating}
        variant="default"
        onClick={onCancel}
      >
        Schließen
      </Button>

      <Group>
        <Button
          color="primary"
          disabled={isCreating || navigationBlocked}
          loading={isSubmitting}
          variant="outline"
          onClick={onSaveProgress}
        >
          Fortschritt speichern
        </Button>
        {activeStep === SiteSetupProcessDataStep.meters && (
          <Button
            color="primary"
            disabled={isSubmitting || navigationBlocked}
            loading={isCreating}
            onClick={onCreateSite}
          >
            Liegenschaft anlegen
          </Button>
        )}
      </Group>
    </Group>
  );
}

export { SiteSetupAssistantFormControls, SiteSetupAssistantFormControlsProps };
